import { ItemTag } from "common/tag/dto/ItemTag";
import CharacterSearchSelect from "components/common/character/util/CharacterSearchSelect";
import UpdateStringList from "components/common/list/UpdateStringList";
import React from "react";
import { ReactRefI } from "type/common/ref.type";

type CharacterRelateGroupEditProps = {
  label: string;
  topicId?: string;
  initialValue: string[];
  resultRef: ReactRefI<string[]>;
  tags?: ItemTag[];
  onUpdate?: Function;
  resultMax?: number;
};

const CharacterRelateGroupEdit = ({
  label,
  topicId,
  initialValue,
  resultRef,
  tags,
  onUpdate,
  resultMax,
}: CharacterRelateGroupEditProps) => {
  const [showEdit, setShowEdit] = React.useState<boolean>(true);

  const onUpdateHandle = () => {
    console.log("onUpdateHandle");
    if (typeof resultMax !== "undefined") {
      if (resultRef.current.length >= resultMax) {
        if (showEdit) {
          setShowEdit(false);
        }
      } else {
        if (!showEdit) {
          setShowEdit(true);
        }
      }
      if (onUpdate) {
        onUpdate();
      }
    }
  };
  return (
    <UpdateStringList
      label={label}
      initialValue={initialValue}
      resultRef={resultRef}
      appendToStart
      disableSingleEdit
      onUpdate={onUpdateHandle}
      stringField={(selHandle: Function) =>
        showEdit && (
          <CharacterSearchSelect
            onLetterSelect={selHandle}
            topicId={topicId}
            tags={tags}
            excludeLetters={resultRef.current}
            onValueSelect={() => {
              console.log("onValueSelect 1");
            }}
          />
        )
      }
      flexRow
    />
  );
};

export default CharacterRelateGroupEdit;
